module.exports = __webpack_public_path__ + "img/keder_blau_candy.ebcaa2d3.jpg";